import { z } from 'zod';
/**
 * The political message of the week (Mesazhi i javës), set by leadership. Activities may name
 * the message they carried, which measures whether a message from the centre turned into
 * action on the ground (docs/18-concerns-and-messages.md).
 */
const day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Zgjidhni datën.');
const fields = {
    title: z.string().trim().min(3, 'Titulli duhet të ketë të paktën 3 shkronja.').max(200),
    summary: z.string().trim().max(1000),
    /** First and last day it is the message of the week (inclusive, YYYY-MM-DD). */
    startsOn: day,
    endsOn: day,
};
const endsAfterStart = {
    message: 'Data e mbarimit duhet të jetë pas fillimit.',
    path: ['endsOn'],
};
export const messageCreateSchema = z
    .object({
    title: fields.title,
    summary: fields.summary.optional(),
    startsOn: fields.startsOn,
    endsOn: fields.endsOn,
})
    .refine((m) => m.endsOn >= m.startsOn, endsAfterStart);
export const messageUpdateSchema = z
    .object({
    title: fields.title.optional(),
    summary: fields.summary.nullable().optional(),
    startsOn: fields.startsOn.optional(),
    endsOn: fields.endsOn.optional(),
})
    .refine((m) => !m.startsOn || !m.endsOn || m.endsOn >= m.startsOn, endsAfterStart);
//# sourceMappingURL=message.js.map